<template>
  <el-dialog :visible.sync="innerVisible" :title="$t('SeaExport.Refuse')" width="400px" custom-class="cargo-form-dialog" :close-on-click-modal="false" :append-to-body="appendToBody" @close="handleClose">
    <div>
      <span>{{ $t('SeaExport.RejectTips', [jobNo]) }}</span>
      <span>
        <el-input v-model="remark" type="textarea" :rows="10" />
      </span>
    </div>
    <span slot="footer" style="padding:10px;">
      <el-button type="primary" @click="handleSubmit">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button @click="handleClose">{{ $t('SeaExport.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>

export default {
  name: 'OpVerifyFrameReject',
  components: { },
  props: {
    visible: { type: Boolean, default: () => false },
    jobNo: { type: String, default: () => ('') },
    rejectCallBack: { type: Function, default: () => (null) },
    appendToBody: { type: Boolean, default: () => false }
  },
  data() {
    return {
      innerVisible: false,
      remark: ''
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
  },
  methods: {
    handleSubmit() {
      if (this.rejectCallBack) {
        this.rejectCallBack(this.remark)
      }
      this.handleClose()
    },
    handleClose() {
      this.remark = ''
      this.innerVisible = false
    }
  }
}
</script>
<style lang="scss">
  .cargo-form-dialog{
    .el-dialog{
      &__header,&__body,&__footer{
        padding:10px 15px!important;
      }
      &__title{
        vertical-align: middle;
      }
      &__headerbtn{
        top:15px;
        right:15px;
      }
    }
  }
  .cargo-form{
    .el-form-item {
      &.label-none {
        .el-form-item__content{
          margin-left: 0;
        }
      }
    }
  }
</style>
